import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { EstoqueContext } from 'contexts/EstoqueContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { decryptURL, findOnArray } from 'utils/functions';
import { useModal, useDialog } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import EtiquetaModal from 'components/Modals/EtiquetaModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Filter from './filter';
import mock from './mock';

const Estoque = () => {
  const rotina = 'EstoqueWms';
  const titulo = 'Estoque';
  const navigate = useNavigate();
  const { hash } = useParams();
  const { filial_id, celocal_id, ceendereco_id } = hash ? decryptURL(hash) : {};
  const { openModal } = useModal();
  const { openDialog } = useDialog();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const { estoque, getEstoque, getLoading } = useContext(EstoqueContext);
  const defaultValues = {
    ...estoque?.filter,
    ...(Boolean(filial_id) && { filial: [filial_id] }),
    ...(Boolean(celocal_id) && { local: [celocal_id] }),
    ...(Boolean(ceendereco_id) && {
      endereco: findOnArray(ceendereco_id, drops?.EnderecoEstoque, 'label'),
    }),
  };
  const { control, getValues, reset } = useForm({ defaultValues });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getEstoque({ ...props, rotina, filter: getValues() });
  };

  const getSubtitulo = () => {
    const arr = [];
    const filial = findOnArray(filial_id, drops?.Filial, 'label');
    const local = findOnArray(celocal_id, drops?.LocalEstoque, 'label');
    const endereco = findOnArray(
      ceendereco_id,
      drops?.EnderecoEstoque,
      'label'
    );
    if (Boolean(filial_id)) {
      arr.push('Filial: ' + filial);
    }
    if (Boolean(celocal_id)) {
      arr.push('Local: ' + local);
    }
    if (Boolean(ceendereco_id)) {
      arr.push('Endereço: ' + endereco);
    }
    return arr?.join(`\n`);
  };

  const options = [
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: estoque?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: estoque?.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={estoque?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Transferência',
      icon: 'sync',
      action: () => navigate('/app/Estoque/Transferencia'),
    },
    {
      name: 'Etiqueta',
      icon: 'print',
      action: (selected) => {
        const arr = selected?.map((s) => ({
          id: s?.id,
          quantidade: s?.quantidade > 0 ? s?.quantidade : 1,
          referencia: s?.referencia,
          descricao: s?.produto,
          variacao: s?.variacao,
          validade: s?.validade,
          rastreabilidade: s?.rastreabilidade,
          unidade_medida: s?.um,
          produto_id: s?.produto_id,
          variacao_id: s?.variacao_id,
        }));

        openDialog(
          <EtiquetaModal itens={arr} armazenagem />,
          'Imprimir Etiquetas'
        );
      },
    },
  ];

  const rowOptions = [];

  return (
    <Container>
      <Header
        rotina={rotina}
        titulo={titulo}
        subtitulo={getSubtitulo()}
        colunas={estoque?.colunas}
      />
      <Card>
        <Grid
          grid={estoque}
          mock={mock}
          options={options}
          rowOptions={rowOptions}
          control={control}
          loading={getLoading}
          checkboxSelection
          loadGrid={loadGrid}
          getRowHeight={() => 'auto'}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter
              grid={estoque}
              control={control}
              drops={drops}
              filial={filial_id}
              local={celocal_id}
              endereco={ceendereco_id}
            />
          }
        />
      </Card>
    </Container>
  );
};

export default Estoque;
